angular.module('SpidApp')

.constant('StockAdapterConfig', {
  name : 'Stock',
  fields : [
    {
    	local   : 'orderable_id',
    	distant : 'orderable_id'
    }, {
    	local   : 'agency_id',
    	distant : 'agency_id'
    }, {
    	local   : 'label',
    	distant : 'label'
    }, {
        local   : 'quantity',
        distant : 'quantity'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})